// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Niue */
const NU = /^(?:(?:[56]|888[1-9])\d{3})$/;

export default NU;
